<template>
  <div>
    <div class="prod_b_index">
      <div>
        <i></i>
        <span>Voucher Center</span>
      </div>
    </div>
    <div class="games">
      <div class="games_module">
        <div class="module_cont">
          <div class="cont">
            <div class="cont_st">
              <div class="list" v-for="(item, index) in gameList" :key="index">
                <div class="list_le">
                  <div>
                    <img :src="item.game_icon" alt="" />
                  </div>
                  <div class="desc">
                    <div>{{ item.game_name }}</div>
                    <div>{{ item.game_desc }}</div>
                  </div>
                </div>
                <div class="list_ri" @click="payPage(item)">Charge</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cust custgame="1"></cust>
  </div>
</template>

<script>
// import { getPayGameList } from '@/api/api';
import { getUrlParams } from '@/utils';
import { axiosServer } from '@/api/http';
import { Dialog, Toast } from 'vant';
import cust from '../../components/customer.vue';
import { setIsKeepAlive } from '../../hooks/useKeepAlive';
export default {
  data() {
    return {
      gameList: [
        {
          product_file_url: require('../../assets/imgs/zf_tab_1.png'),
          product_name: '九灵神域',
          desc: '测试测试测试测试测试测试测试测试'
        },
        {
          product_file_url: require('../../assets/imgs/zf_tab_1.png'),
          product_name: '九灵神域',
          desc: '测试测试测试测试测试测试测试测试'
        }
      ],
      from: ''
    };
  },
  components: {
    cust
  },
  created() {
    this.from = getUrlParams('from') || this.$route.query.from;
    console.log(this.from);
    this.getPayGames();
  },
  methods: {
    getPayGames() {
      Toast.loading();
      axiosServer({
        url: 'getPayGameList',
        type: 'post',
        params: {
          // order_id: this.$route.query.order_id,
          // sign: getSign(this.app_key, { order_id: this.$route.query.order_id }),
        }
      }).then(res => {
        Toast.clear();
        if (res.data.ret == 0) {
          this.gameList = res.data.data.list;
        } else {
          Dialog.alert({ message: res.data.msg });
        }
      });
    },
    async payPage(data) {
      setIsKeepAlive(false);
      await this.$router.push({
        path: '/',
        query: { game_id: data.game_id, area: data.area, from: this.from }
      });
      setIsKeepAlive(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.prod_b_index {
  width: 100%;
  background: #fff;
  padding: 0.23rem 0.28rem;
  div {
    line-height: 0.5rem;
  }
  div i {
    width: 0.12rem;
    height: 0.5rem;
    background: #4378ff;
    display: inline-block;
    vertical-align: top;
  }
  div span {
    margin-left: 0.13rem;
    font-size: 0.28rem;
    color: #010101;
  }
}
.games {
  padding: 0.2rem 0rem;
  .games_list {
    width: 100%;
    background: #fff;
  }
}
.games_module {
  width: 100%;
  background: #f1f1f1;
  .module_cont {
    padding: 0.1rem 0.1rem 0;
    .cont {
      border-radius: 0.15rem;
      .cont_st {
        padding: 0.2rem 0.05rem;
        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.2rem;
          background: #fff;
          padding: 0.15rem 0.1rem;
          align-items: center;
          .list_le {
            display: flex;
            align-items: center;
            img {
              width: 1.3rem;
            }
            .desc {
              margin-left: 0.2rem;
              width: 3rem;
              div:nth-child(1) {
                color: #010101;
                font-size: 0.3rem;
                overflow-wrap: break-word;
                word-break: keep-all;
              }
              div:nth-child(2) {
                color: #666;
                font-size: 0.22rem;
                margin-top: 0.1rem;
              }
            }
          }
          .list_ri {
            width: 1.47rem;
            height: 0.45rem;
            border-radius: 0.08rem;
            background: #4378ff;
            color: #fff;
            text-align: center;
            line-height: 0.45rem;
            font-size: 0.22rem;
          }
        }
      }
    }
  }
}
</style>
